module.exports = __webpack_public_path__ + "img/img4.70458d21.png";